import { Avatar } from '@lmc/ui-kit'
import styled from 'styled-components'
import MultiSelect from '../MultiSelect/MultiSelect'

type GroupedOptionsMultiSelectProps = {
  groupedOptions: { [status: string]: any[] }
  title: string
  values?: string[]
  handleInputChange: (newValue: any) => void
  [key: string]: any
}

const getName = (item: { name?: { first?: string; last?: string } }) =>
  `${item?.name?.first} ${item?.name?.last}`

const GroupedOptionsMultiSelect = ({
  groupedOptions,
  title,
  values,
  handleInputChange,
  ...props
}: GroupedOptionsMultiSelectProps) => {
  Object.keys(groupedOptions).forEach((key) => {
    if (groupedOptions[key].length === 0) {
      delete groupedOptions[key]
    } else {
      groupedOptions[key].sort((a, b) => {
        const nameA = getName(a)
        const nameB = getName(b)
        return nameA.localeCompare(nameB)
      })
    }
  })

  const groupedOptionOptions = Object.keys(groupedOptions).map((status) => ({
    label: status.toLocaleUpperCase(),
    options: groupedOptions[status].map((option) => ({
      label: getName(option),
      value: option.id,
      image: <Avatar url={option.picture as unknown as string} size={20} />
    }))
  }))

  return (
    <StyledWideMultiSelect
      values={values}
      title={title}
      groupedOptions={groupedOptionOptions}
      hasClear
      hasSearch
      hasSelectAll
      onChange={handleInputChange}
      {...props}
    />
  )
}

const StyledWideMultiSelect = styled(MultiSelect)`
  min-width: 200px;
` as unknown as typeof MultiSelect

export default GroupedOptionsMultiSelect
